import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3944";

export interface MerchantAccount {
  id: string;
  merchant_id: string;
  merchant_code: string;
  merchant_secrete: string;
  institution_code: string;
  status: number;
  created_at: string;
  updated_at: string;
}

export interface InstitutionInfo {
  institution_name: string;
  email: string;
  telephone: string;
  address: string;
  sector: string;
  legal_status: string;
  idnat: string;
  nif: string;
  rccm: string;
  website: string;
}

export interface MerchantProfile {
  merchant: MerchantAccount;
  institution: InstitutionInfo;
  user: {
    firstname: string;
    lastname: string;
    email: string;
  };
}

export const merchantService = {
  async getMerchantProfile(): Promise<MerchantProfile> {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_URL}/merchants/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  async regenerateSecret(): Promise<{ merchant_secrete: string; updated_at: string }> {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${API_URL}/merchants/regenerate-secret`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },

  async updateCallbackUrls(urls: {
    success_url: string;
    failure_url: string;
    notification_url: string;
  }): Promise<boolean> {
    const token = localStorage.getItem("token");
    await axios.put(`${API_URL}/merchants/callback-urls`, urls, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return true;
  },
};